<template>
  <el-cascader
  ref='ownArea'
    v-model="val"
    :clearable="clearable"
    :size="size"
    :options="diseaseOptions"
    :props="cascaderProps"
    :disabled="disabled"
    :placeholder="placeholder"
    :show-all-levels="false"
    @visible-change="visibleChange"
    @expand-change="expandChange"
    :popper-class="popperClass"
    filterable
    @change="changeHandle"
  >
  </el-cascader>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter'
import { getGrantedDiseasesTreeApi, isWelfareBabyApi } from "@/util/api";

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  mixins: [emitter],
  props: {
    value: [String, Array],
    disabled: false,
    multiple: false,
    placeholder: {
      type: String,
      default: '请选择'
    },
    hospitalId: {
      type: String
    },
    clearable: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data () {
    return {
      val: this.value,
      popperClass: 'disease-cascader-last',
      diseaseOptions: [],
      cascaderProps: {
        multiple: this.multiple,
        emitPath: false,
        value: 'diseasesId',
        label: "diseasesName",
        children: "childDiseasesList"
      }
    }
  },
  watch: {
    value: {
      deep: true,
      // immediate: true,
      handler: function(value) {
        this.val = value;
        this.changeHandle(value);
      }
    },
    hospitalId: {
      handler: function () {
        this.loadData();
      }
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      await getGrantedDiseasesTreeApi({
        hospitalId: this.hospitalId
      }).then(res => {
        if (res.msgCode == 200) {
          this.diseaseOptions = res.responseData
        } else {
          this.$message.error(res.msg)
        }
      }).catch()
    },
    async changeHandle (id) {
      if (id != undefined && this.diseaseOptions && this.diseaseOptions.length > 0) {
        let initialProject = this.disabledOption(id);
        let diseasesList = Array.isArray(id) ? id.map(v => {
          return { diseasesId: v }
        }) : (id ? [{ diseasesId: id }] : null);
        this.val = id;
        if (this.hospitalId && diseasesList && diseasesList.length > 0) {
          await isWelfareBabyApi({
            hospitalId: this.hospitalId,
            diseasesList: diseasesList
          }).then(res => {
            if (res.msgCode == 200) {
              this.dispatch('ElFormItem', 'el.form.change', this.val);
              this.dispatch('ElFormItem', 'el.form.blur', this.val);
              // 病种id数组，是否公益宝贝，是否天使项目
              this.$emit('change', this.val, res.responseData == 1, initialProject == 'AY1002', initialProject);
            }
          });
        } else {
          this.dispatch('ElFormItem', 'el.form.change', this.val);
          this.dispatch('ElFormItem', 'el.form.blur', this.val);
          this.$refs.ownArea.dropDownVisible = false;
          this.$emit('change', this.val, null, initialProject == 'AY1002', initialProject);

        }
      }
    },
    disabledOption (id) {
      let initialProject = this.getInitialProject(id); // 获取字符串 例：'AY1002'
  /*    let isAngleDiseases = initialProject == 'AY1002'; //true 或 false
      if (isAngleDiseases) {
        this.diseaseOptions = this.diseaseOptions.map(d => {
          d.disabled = d.initialProject != 'AY1002';
          return d;
        })
      } else if (id && id.length > 0) {
        this.diseaseOptions = this.diseaseOptions.map(d => {
          d.disabled = d.initialProject == 'AY1002';
          return d;
        })
      } else {
        this.diseaseOptions = this.diseaseOptions.map(d => {
          d.disabled = false;
          return d;
        })
      }*/

      let isAngleDiseases = initialProject == 'AY1002'; //true 或 false
      let isTongfXinDiseases = initialProject == 'AY1001'; //true 或 false
      let isChengXinDiseases = initialProject == 'AY1003'; //true 或 false
      if (isAngleDiseases) {
        this.diseaseOptions = this.diseaseOptions.map(d => {
          d.disabled = d.initialProject != 'AY1002';
          return d;
        })
      } else if(isTongfXinDiseases) {
        this.diseaseOptions = this.diseaseOptions.map(d => {
          d.disabled = d.initialProject != 'AY1001';
          return d;
        })
      }else if(isChengXinDiseases){
        this.diseaseOptions = this.diseaseOptions.map(d => {
          d.disabled = d.initialProject != 'AY1003';
          return d;
        })
      }else {
        this.diseaseOptions = this.diseaseOptions.map(d => {
          d.disabled = false;
          return d;
        })
      }

      this.dispatch('ElFormItem', 'el.form.change', this.val);
      this.dispatch('ElFormItem', 'el.form.blur', this.val);
      return initialProject;
    },
    getInitialProject (ids) {
      let lastDiseasesList = [];
      this.expandDiseasesData(this.diseaseOptions, lastDiseasesList);
      let diseasesList = Array.isArray(ids) ? ids : [ids];
      let initialProject = {};
      lastDiseasesList.map(d => {
        if (diseasesList.indexOf(d.diseasesId) > -1) {
          initialProject[d.initialProject] = 1;
        }
      });
      let initialProjectList = [];
      for (let key in initialProject) {
        initialProjectList.push(key);
      }
      // 规则：
      // 1. 如果包含天使，即为天使项目；
      // 2. 如果同时包含童心、晨星，即为童心项目；
      if (initialProjectList.indexOf('AY1002') > -1) {
        return 'AY1002';
      } else if (initialProjectList.length > 1) {
        return 'AY1001';
      } else if (initialProjectList.length > 0) {
        return initialProjectList[0];
      } else {
        return null;
      }
    },
    expandDiseasesData (list, data) {
      list.map(d => {
        if (d.childDiseasesList && d.childDiseasesList.length > 0) {
          this.expandDiseasesData(d.childDiseasesList, data);
        } else {
          data.push(d);
        }
      });
    },
    expandChange (nodes) {
      this.disabledOption(this.val)
      setTimeout(function () {
        let arrowList = document.getElementsByClassName('el-icon-arrow-right');
        for (let i = 0; i < arrowList.length; i++) {
          let dom = arrowList[i];
          let checkboxList = dom.parentNode.getElementsByClassName('el-checkbox');
          for (let j = 0; j < checkboxList.length; j++) {
            checkboxList[j].setAttribute('style', 'display: none;');
          }
        }
      }, 100)
    },
    visibleChange (e) {
      if (e) {
        this.expandChange();
      }
    }
  }
}
</script>

<style lang="scss">
// .disease-cascader {
//   .el-cascader-menu {
//     .el-cascader-node {
//       .el-checkbox {
//         display: none;
//       }
//     }
//   }
// }
.disease-cascader-last {
  .el-cascader-menu {
    .el-cascader-node {
      .el-checkbox {
        display: none;
      }
    }
  }
  .el-cascader-menu:last-child {
    .el-cascader-node {
      .el-checkbox {
        display: block;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/business/DiseaseCascader.vue